window.addEventListener('load', () => {
  const toggle = document.querySelector('.cs-user-menu');
  const menu = document.querySelector('.cs-user-menu + ul');

  if (toggle) {
    document.body.addEventListener('click', () => {
      toggle.classList.remove('is-open');
      menu.classList.remove('open');
    });

    toggle.addEventListener('click', (e) => {
      e.stopPropagation();
      toggle.classList.toggle('is-open');
      menu.classList.toggle('open');
    });

    menu.addEventListener('click', (e) => {
      e.stopPropagation();
    });
  }
});
